"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOptionToAfm = exports.mapRelativeFilterToAfm = exports.mapAbsoluteFilterToAfm = void 0;
// (C) 2007-2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var PeriodExclusion_1 = require("./PeriodExclusion");
var interfaces_1 = require("../interfaces");
exports.mapAbsoluteFilterToAfm = function (value, dataSet) { return ({
    absoluteDateFilter: {
        dataSet: dataSet,
        from: value.from,
        to: value.to,
    },
}); };
exports.mapRelativeFilterToAfm = function (value, dataSet) { return ({
    relativeDateFilter: {
        dataSet: dataSet,
        from: value.from,
        to: value.to,
        granularity: value.granularity,
    },
}); };
exports.mapOptionToAfm = function (value, dateDataSet, excludeCurrentPeriod) {
    var excludeApplied = PeriodExclusion_1.applyExcludeCurrentPeriod(value, excludeCurrentPeriod);
    if (sdk_model_1.isAllTimeDateFilterOption(excludeApplied)) {
        return null;
    }
    if (interfaces_1.isAbsoluteDateFilterOption(excludeApplied)) {
        return exports.mapAbsoluteFilterToAfm(excludeApplied, dateDataSet);
    }
    if (interfaces_1.isRelativeDateFilterOption(excludeApplied)) {
        return exports.mapRelativeFilterToAfm(excludeApplied, dateDataSet);
    }
    throw new Error("Unknown date filter value provided");
};
//# sourceMappingURL=AFMConversions.js.map